export default "__VITE_ASSET__DMOUtKQS__"